/**
 * The country a fresh phone field opens on when the field names none itself:
 * no saved `+…` number and no registry `default_country` (D6 of
 * docs/plans/canvas-layout-and-app-polish.md).
 *
 * One provider near the root gives it to every phone field in the app, so no
 * form has to pass it down. The web's root reads the workspace's country off
 * its locale (`app.tenant.locale`, en-IN is India), then the person's region;
 * the phone's root gives the workspace's country, and its field asks the SIM
 * and device only when that is null. Null outside a provider, and while nothing is known:
 * the field then goes on to its own guesses, and India last.
 */
import { createContext, createElement, useContext, type ReactElement, type ReactNode } from 'react';

const PhoneCountryContext = createContext<string | null>(null);

export function PhoneCountryProvider({
  iso,
  children,
}: {
  /** ISO 3166-1 alpha-2, or null when the workspace and the person name none. */
  readonly iso: string | null;
  readonly children?: ReactNode;
}): ReactElement {
  return createElement(PhoneCountryContext.Provider, { value: iso }, children);
}

/** The provider's country, or null without one. */
export const usePhoneCountry = (): string | null => useContext(PhoneCountryContext);
